<template>
    <div class="icon-tooltip-container">
        <div class="icon-tooltip" v-if="isHovered">
            <div v-if="isHtml" v-html="`<p>${tooltipMessage}</p>`" class="icon-tooltip__message text-avenir-book"></div>
            <div v-else class="icon-tooltip__message text-avenir-book">{{ tooltipMessage }}</div>
        </div>
        <div @mouseover="showTooltip" @mouseout="hideTooltip" @click="$event.stopPropagation()">
            <template v-if="isIcomoonIcon">
                <span :class="iconClass"></span>
            </template>
            <template v-else>
                <FontAwesomeIcon class="icon-tooltip-icon" :icon="iconClass"> </FontAwesomeIcon>
            </template>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
    name: 'IconTooltip',
    components: {
        FontAwesomeIcon
    },
    props: {
        isHtml: {
            type: Boolean,
            default: false,
        },
        tooltipMessage: {
            type: String,
            default: null,
        },
        iconClass: {
            type: String,
            default: 'fa-solid fa-triangle-exclamation',
        },
        isIcomoonIcon: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isHovered: false,
        };
    },
    methods: {
        showTooltip(event) {
			event.stopPropagation();
            this.isHovered = true;
        },
        hideTooltip(event) {
			event.stopPropagation();
            this.isHovered = false;
        },
    },
};
</script>
